class ReleaseNotesSettingsService {
    constructor(client) {
        this.apiClient = client;
    }

    async get() {
        return this.apiClient.get("releasenotessettings");
    }

    async put(settings) {
        return this.apiClient.put("releasenotessettings", settings);
    }
}

export default ReleaseNotesSettingsService;
